module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "observe-visibility",
      rawName: "v-observe-visibility",
      value: ({
        callback: this.visibilityChanged,
        throttle: 100
      }),
      expression: "{\n    callback: this.visibilityChanged,\n    throttle: 100\n  }"
    }],
    staticClass: "section",
    attrs: {
      "id": "home",
      "data-id": "0"
    }
  }, [_c('div', {
    staticClass: "border-grid"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5bbf6bc","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SectionHome.vue
// module id = 65
// module chunks = 0